<template>
  <div class="payment">
    <transition name="fade">
      <grid-loader :done="httpSuccess" @complete="success" :error="status.failed" v-if="loading" full/>
      <div v-else>
        <payment-success v-if="status.success" @close="$emit('close')"/>
        <payment-failed v-if="status.failed" :error="error" @close="$emit('close')"/>
      </div>
    </transition>

    <transition name="fade">
      <refill-values @next="gotoCC" v-if="step === 1" @close="$emit('close')" />
      <card-list
        @forceLoad="loading = true"
        @proceed="handleCharge"
        @load="loading = false"
        @cancel="$emit('close')"
        @close="$emit('close')"
        v-if="step === 2" />
    </transition>

  </div>
</template>

<script>
import CardList from './CardList'
import PaymentSuccess from './payment-state/Success'
import PaymentFailed from './payment-state/Failed'
import GridLoader from '@/components/shared/loaders/GridLoader'
import RefillValues from './RefillValues'

export default {
  name: 'Payment',
  components: { CardList, PaymentSuccess, GridLoader, RefillValues, PaymentFailed },
  props: {},
  data () {
    return {
      step: 1,
      amount: 0,
      loading: false,
      status: {
        success: false,
        failed: false
      },
      httpSuccess: false,
      error: '',
      transaction: {}
    }
  },
  methods: {
    gotoCC (options) {
      this.amount = options.amount
      this.loading = true
      this.step = 2
    },
    success () {
      this.loading = false
      if (this.status.failed) {
        this.$emit('failed')
      }

      if (this.status.success) {
        this.$emit('complete', this.transaction)
      }
    },
    async handleCharge (data) {
      this.loading = true
      const dataObj = {
        amount: parseInt(this.amount),
        cardId: data.id,
        token: data.token ? data.token.id : null
      }

      try {
        const response = await this.$http.post(this.$api.payments.charges, dataObj)
        this.httpSuccess = true
        this.transaction = response.data
        this.status.success = true
      } catch (e) {
        this.httpSuccess = true
        this.status.failed = true
        this.error = e.response.data['']
      }
    }
  },
  created () {},
  mounted () {}
}
</script>

<style lang="scss" scoped>

  .autorefill-loading {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 9999999;
      height: 100vh;
      width: 100%;
      background-color: white;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

  .payment-pending {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999999;
  }

  .loader {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
  }

  .payment {
    height: 100vh;
    @include breakpoint (xs) {
      //height: calc(100vh - 50px);
    }
  }

  .payment-loaded {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .p-header {
    width: 100%;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //background-color: #f5f9ff;
    box-sizing: border-box;
    color: $text-light;
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 12px;
    padding-bottom: 40px;
  }

  .payment-information {
    position: relative;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    flex-grow: 1;
    justify-self: stretch;
    box-shadow: 0px -2px 12px 0px rgba($text-light, 0.1);
    background-color: white;
    padding: 40px;

    &.payment-details {
      justify-content: flex-start;
      align-items: flex-start;

      .save-card-checkbox {
        margin-top: 20px;
      }

      h1 {
        margin-top: 0;
        font-weight: 600;
        font-size: 12px;
        color: $text-light;
        text-transform: uppercase;
      }

      p {
        font-size: 14px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 2px 0px;
        color: $text;

        &.total {
          padding-top: 25px;
          justify-content: center;
          margin-bottom: 25px;
          margin-top: 25px;
          font-size: 16px;
          font-weight: 600;

          span {
            padding-right: 10px;
          }
        }
      }

      div.total {
        box-sizing: border-box;
        width: 100%;
      }
    }

    &.ARI {
      button {
        margin-top: 30px;
      }
    }

    .input-split {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .save-card {
      align-self: flex-start;
      margin: 20px 0;
    }

    button {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/saldoAndCredit/Payment.vue